import { render, staticRenderFns } from "./CoverUploader.vue?vue&type=template&id=e1efd2c8&scoped=true"
import script from "./CoverUploader.vue?vue&type=script&lang=js"
export * from "./CoverUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1efd2c8",
  null
  
)

export default component.exports